var $c03aa2dde3f54f51$exports = {};
$c03aa2dde3f54f51$exports = {
    "Empty": `\u{641}\u{627}\u{631}\u{63A}`
};


export {$c03aa2dde3f54f51$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
